import axios from "axios";

import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

const getOrderItems = async (id) => {
    const response = await axios.get(routes.getOrderItems(id), AXIOS_DEFAULT_CONFIG);
    return response;
}
export default getOrderItems;